export const TagTypes = Object.freeze({
  ME: "me",
  DRIVER_DOCUMENTS: "driverDocuments",
  ACCEPTANCE: "acceptance",
  DRAWDOWN_RELATED: "drawdownRelated",
  FLEET_TERMS_AND_CONDITIONS: "fleetTermsAndConditions",
});
